module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-t-10 m-b-10 p-20 bor-ccc pos-rel"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', [_vm._t("default")], true)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78cae31c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/normal/formBlock.vue
// module id = 1932
// module chunks = 2